module.exports = __webpack_public_path__ + "media/images/captive_portal/Upcoming-0b28cd410213c5166d1249f76d7874bb.svg";